<template>
    <span class="overview_graph_value" ref="valueSpan">
    {{ commify(value) }}<span v-if="(typeof value === 'number')">,<span class="decimal">{{
                value.toFixed(2).split('.')[1]
            }}</span><span class="currency">{{ unit }}</span>
    </span>
    </span>
</template>

<script>
export default {
    name: 'overview-graph-value',
    props: ['value', 'unit'],
    methods: {
        commify(n) {
            if (typeof n === 'number') {
                const parts = Math.trunc(n).toFixed(0).split('.');
                const numberPart = parts[0];
                const thousands = /\B(?=(\d{3})+(?!\d))/g;
                return numberPart.replace(thousands, '.');
            } else {
                return n;
            }
        },
    },
    mounted() {
        // Zvětšení na velikost dvou dlaždic, pokud hodnota přetéká
        const el = this.$refs['valueSpan']
        if (el.scrollWidth > el.offsetWidth) {
            const holder = el.closest('.holder')
            holder.style.minWidth = (165 * 2 + 10) + 'px'
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/templates/part/ui/overview-graph-value.vue